import React from 'react'
import Lottie from 'react-lottie';
import animationData from '../lotties/404.json';

const PageNotFound = () => {
//animation lotty
const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };
  
    return (
        <div>
            {/* <h3 style={{textAlign:'center'}}>This page could not be found</h3> */}
            <Lottie 
            options={defaultOptions}           
            /> 
        </div >
    )
}

export default PageNotFound
